// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bo-core/instanceLayoutEditor/instanceLayoutEditor.css
// module id = 780
// module chunks = 1